module.exports = __webpack_public_path__ + "img/modal.237353cb.png";